
export const LOAD_DASHBOARD_DATA_IN_PROGRESS = "LOAD_DASHBOARD_DATA_IN_PROGRESS";
export const loadDashboardDataInProgress = () => ({
  type: LOAD_DASHBOARD_DATA_IN_PROGRESS,
});

export const LOAD_DASHBOARD_DATA_SUCCESS = "LOAD_DASHBOARD_DATA_SUCCESS";
export const loadDashboardDataSuccess = (data) => ({
  type: LOAD_DASHBOARD_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_DASHBOARD_DATA_FAILURE = "LOAD_DASHBOARD_DATA_FAILURE";
export const loadDashboardDataFailure = () => ({
  type: LOAD_DASHBOARD_DATA_FAILURE,
});

export const LOAD_DASHBOARD_WIDGETS_LIST_SUCCESS = "LOAD_DASHBOARD_WIDGETS_LIST_SUCCESS";
export const loadDashboardWidgetsListSuccess = (data) => ({
  type: LOAD_DASHBOARD_WIDGETS_LIST_SUCCESS,
  payload: { data },
});

export const DASHBOARD_OPERATION_COMPLETED = "DASHBOARD_OPERATION_COMPLETED";
export const dashboardOperationCompleted = () => ({
  type: DASHBOARD_OPERATION_COMPLETED,
});

export const LOAD_DASHBOARD_USER_WIDGETS_LIST_SUCCESS = "LOAD_DASHBOARD_USER_WIDGETS_LIST_SUCCESS";
export const loadDashboardUserWidgetsListSuccess = (data) => ({
  type: LOAD_DASHBOARD_USER_WIDGETS_LIST_SUCCESS,
  payload: { data },
});